import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/Users/erinwang/Documents/GitHub/portfolio-v3/src/components/portfolio-page.js";
import { Link } from 'gatsby';
import { SingleImage, MultiImage, MultiImageContainer } from '../../src/components/portfolio-page';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h2>{`Northeastern University Association of Gaming Enthusiasts`}</h2>
    <p>{`During my time at `}<a parentName="p" {...{
        "href": "https://gamingnu.wixsite.com/nuage"
      }}>{`Northeastern University Association of Gaming Enthusiasts`}</a>{`, or Northeastern's board game club, I was asked to design a handful of t-shirts.
We managed to sell over 50+ shirts every year, raising over hundreds of dollars which were used to run club events and fund fun dining and recreational experiences.`}</p>
    <MultiImageContainer mdxType="MultiImageContainer">
    <MultiImage src='../../images/tshirts/meeple.png' mdxType="MultiImage" />
    <MultiImage src='../../images/tshirts/3dgame.png' mdxType="MultiImage" />
    </MultiImageContainer>
    <h2>{`Northeastern University Class of 2021 t-shirt`}</h2>
    <p>{`Every year, Northeastern hosts a contest for the senior class' t-shirt. I won that contest with the design below! `}</p>
    <MultiImageContainer mdxType="MultiImageContainer">
    <MultiImage src='../../images/tshirts/2021nu.png' mdxType="MultiImage" />
    </MultiImageContainer>
 
 
    <h2>{`10th year AskReddit Anniversary`}</h2>
    <p>{`In 2018, I won a `}<a parentName="p" {...{
        "href": "https://www.redditinc.com/blog/celebrating-ten-years-of-r-askreddit"
      }}>{`AskReddit's 10th year anniversary t-shirt design contest!`}</a>{`. All funds for the shirt went towards Doctors Without Borders.`}</p>
    <MultiImageContainer mdxType="MultiImageContainer">
    <MultiImage src='../../images/tshirts/askreddit.png' mdxType="MultiImage" />
    </MultiImageContainer>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      